import BaseApi from './base-api';
import {ApiPaths} from './const';


class AppApi extends BaseApi {
    checkPermission(params) {
        return this.request_v1(ApiPaths.CHECK_PERMISSION, params, null, 'POST');
    }
    saveTracking(params) {
        return this.request_v1(ApiPaths.SAVE_TRACKING, params, null, 'POST');
    }

}

const AppApiInstance = new AppApi();

export {BaseApi, AppApiInstance};
